<template>
    <div class="container">
        <div class="d-breadcrumb breadcrumb">
            <ul v-if="breadcrumbList.length > 1">
                <li
                    v-for="(breadcrumb, index) in breadcrumbList"
                    :key="index"
                    :class="{'is-active' : !hasRoute(index)}">
                    <component
                        :is="hasRoute(index) ? 'router-link': 'a'"
                        :to="routeTo(index)"
                    >{{ breadcrumb.name }}</component>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumb',
    data () {
        return {
            breadcrumbList: []
        }
    },
    mounted () {
        this.updateList() 
    },
    watch: {
        '$route' () {
            this.updateList()
        } 
    },
    methods: {
        hasRoute(to) {
            return this.breadcrumbList[to].link
        },
        routeTo (to) {
            if (this.hasRoute(to)) {
                return this.breadcrumbList[to].link
            }
        },
        updateList () {
            this.breadcrumbList = this.$route.meta.breadcrumbs || []
        }
    }
}
</script>
